<template>
  <div>
    <div class="ban-p">
      <img
        v-if="result && result.headerImg"
        :src="imageUrl + result.headerImg"
      />
    </div>
    <div class="g-snva1">
      <div class="wp">
        <subnav :type="1"></subnav>
      </div>
    </div>
    <div class="wp">
      <div class="m-hon">
        <ul class="ul-holist" v-if="honorImgs && honorTexts">
          <viewer :images="honorImgs">
            <li v-for="(item, index) of honorImgs" :key="index">
              <div class="con">
                <div class="pic">
                  <img :src="imageUrl + item" />
                </div>
                <div class="txt">
                  {{ honorTexts[index] }}
                </div>
              </div>
            </li>
          </viewer>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import subnav from '@/components/subnav';

export default {
  components: {
    subnav
  },
  data () {
    return {
      loading: true,
      result: null,
      honorImgs: [],
      honorTexts: [],

      pageInfo: {
        zhId: '1436503810528223234',
        enId: '1436503778160779265'
      }
    }
  },
  mounted () {
    let lang = localStorage.getItem("locale") || 'zh';
    this.lang = lang;
    this.$i18n.locale = lang;
    Loading.service();
    let that = this;
    if (that.$i18n.locale === 'zh') {
      that.getHonor(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getHonor(that.pageInfo.enId);
    }
  },
  watch: {
    '$i18n.locale' (newValue) {
      Loading.service();
      if (this.$i18n.locale === 'zh') {
        this.getHonor(this.pageInfo.zhId);
      } else if (this.$i18n.locale === 'en') {
        this.getHonor(this.pageInfo.enId);
      }
    }
  },
  methods: {
    // 获取荣誉信息
    getHonor (id) {
      let that = this;
      let data = {
        id: id
      };
      that.$http
        .getHonor(data)
        .then((res) => {
          if (res.code == 200) {
            let result = res.result;
            that.result = result;
            that.honorImgs = result.honorImgs ? result.honorImgs.split(',') : [];
            that.honorTexts = result.honorTexts ? result.honorTexts.split('\n') : [];
            Loading.service().close();
          }
        })
        .catch((err) => {
          that.$message(
            {
              message: err,
              type: 'error'
            }
          );
        });
    },
  },
}
</script>

<style>
</style>